import React from "react";

import "./footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <ul className="footer-link">
        <li className="li-first-item">Travelo.com</li>
        <li>Share and Find your next travel destination with our service!</li>
      </ul>
      <ul className="footer-useful-links">
        <li className="li-first-item">Useful Links</li>
        <li>All Places</li>
      </ul>
      <ul className="footer-category">
        <li className="li-first-item">Category</li>
        <li>FAQ</li>
      </ul>
      <ul className="footer-my-account">
        <li className="li-first-item">My Account</li>
        <li>My Account</li>
        <li>Login / Sign Up</li>
      </ul>
      <ul className="footer-contact-info">
        <li className="li-first-item">Contact Info</li>
        <li>Created By Sam Ruiz</li>
        <li>
          <a href="https://samluvs.pizza/" className="footer-link">
            Personal Website
          </a>
        </li>
      </ul>
    </footer>
  );
};

export default Footer;
